import React, { useMemo, useState } from "react";
import Switch from "rc-switch";
import numeral from "numeral";
import classnames from "classnames";
// import { developer, developerPro, enterprise } from "./pricing";
import { Button } from "../../components/Button";
import Slider from "rc-slider";
import Tooltip from "rc-tooltip";
import { ConsultModal } from "../../components/ConsultModal";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import "./styles.less";
import { tryNow } from "../../utils";
import { ConsultFormModal } from "../../components/CommonFormModal";

// TODO 等子强文案
// const FreeFeatureList = (props) => {
//   const { t } = useTranslation();
//   return (
//     <div
//       style={{
//         width: "220px",
//         padding: "0 12px",
//       }}
//     >
//       <h5
//         style={{
//           textAlign: "center",
//         }}
//       >
//         {t("price.priceList.alsoInclude")}
//       </h5>
//       {props.features.map((item, index) => {
//         return (
//           <p key={index} className="free-feature-list-item">
//             <i
//               style={{
//                 marginRight: "12px",
//                 fontSize: "12px",
//               }}
//               className="icon authing-icon authing-mark"
//             ></i>
//             {item}
//           </p>
//         );
//       })}
//     </div>
//   );
// };

const PriceListItem = (props) => {
  const {
    features,
    min,
    max,
    defaultValue,
    title,
    onPurchase,
    button,
    plans,
    marks,
    theme,
    payeType,
    // freeInfo,
  } = props;
  const [index, setIndex] = useState(defaultValue);
  const { t } = useTranslation();
  const cls = classnames({
    "price-list-item": true,
    dark: theme === "dark",
  });
  const _onChange = (index) => {
    setIndex(index);
  };

  const mau = useMemo(() => {
    return plans && plans[index].max;
  }, [index, plans]);

  // 这里写的有问题。
  const price = useMemo(() => {
    return payeType === "mounthly"
      ? plans && plans[index].price
      : plans && plans[index].price === "--"
      ? "--"
      : plans && plans[index].price * 10;
  }, [index, payeType, plans]);

  const payeTypeStr =
    payeType === "mounthly"
      ? `${t("price.priceList.month-unit")}`
      : `${t("price.priceList.year-unit")}`;

  const _onPurchase = () => {
    if (price !== "--") {
      tryNow();
      return;
    }
    onPurchase && onPurchase();
  };

  return (
    <div className={cls}>
      <div className="item-num-warp">
        <div className="list-item-title">{title}</div>
        {plans && plans.length > 1 ? (
          <div>
            <div className="list-item-num">
              {price === "--" ? (
                <span className="list-item-num-detail">
                  {t("common.button.contact-us")}
                </span>
              ) : (
                <div className="list-item-num-detail">
                  <span className="list-item-num-icon">¥</span>{" "}
                  <span>{numeral(price).format("0,0")}</span>
                  <span className="list-item-num-unit">/{payeTypeStr}</span>
                </div>
              )}
            </div>
            <div className="list-item-bar">
              <Slider
                {...{ min, max, value: index, marks }}
                step={null}
                onChange={_onChange}
                className="price-slider"
              />
            </div>
            <div className="list-item-tip" style={{ cursor: "default" }}>
              {typeof mau === "number" ? numeral(mau).format("0,0") : mau}{" "}
              {t("price.priceList.unit")}
              <Tooltip
                placement="bottom"
                mouseLeaveDelay={0.001}
                trigger={["hover"]}
                overlay={<div>{t("price.priceList.common-tip")}</div>}
              >
                <span>
                  <span>{t("price.priceList.MAU")}</span>
                  <i
                    className="icon authing-icon authing-problem"
                    style={{ color: "#aaaaaa", marginLeft: 6 }}
                  ></i>
                </span>
              </Tooltip>
            </div>
          </div>
        ) : (
          <div>
            <div className="contact-title">{t("common.button.contact-us")}</div>
            <div className="contact-content">
              {t("price.priceList.contact-sales")}
            </div>
          </div>
        )}
      </div>
      <div className="price-button">
        <Button onClick={_onPurchase}>
          {price === "--" ? `${t("common.button.contact-us")}` : button}
        </Button>
      </div>
      <div className="item-feature-warp">
        {/* <div className="item-feature"> */}
        {/* TODO 等子强加文案 */}
        {/* <Tooltip
            placement="bottom"
            mouseLeaveDelay={0.001}
            trigger={["hover"]}
            overlay={<FreeFeatureList features={freeInfo.features} />}
          > */}
        {/* <div style={{ fontWeight: 600 }} className="item-feature-title">
            {freeInfo.title}
          </div> */}
        {/* </Tooltip> */}
        {/* </div> */}
        {features.map((feature, index) => {
          const tip = <div style={{ maxWidth: 200 }}>{feature.tip}</div>;
          return (
            <div key={index} className="item-feature">
              {feature?.tip ? (
                <Tooltip
                  placement="bottom"
                  mouseLeaveDelay={0.001}
                  trigger={["hover"]}
                  overlay={tip}
                >
                  <div className="item-feature-title">
                    <span>
                      {feature.link ? (
                        <Link to={feature.link} className="item-link">
                          {feature.title}
                        </Link>
                      ) : (
                        feature.title
                      )}
                    </span>
                    <i
                      className="icon authing-icon authing-problem"
                      style={{ color: "#aaaaaa", marginLeft: 6 }}
                    ></i>
                  </div>
                </Tooltip>
              ) : (
                <div style={{ width: "fit-content" }}>{feature.title}</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const PriceList = () => {
  const [payeType, setPayType] = useState("mounthly");
  const { t } = useTranslation();

  const monthCls = classnames({
    "paye-type": true,
    selected: payeType === "mounthly",
  });
  const annuallyCls = classnames({
    "paye-type": true,
    selected: payeType === "annually",
  });
  const [visible, setVisible] = useState(false);

  const onSwitch = () => {
    if (payeType === "mounthly") {
      setPayType("annually");
    } else {
      setPayType("mounthly");
    }
  };

  const onPurchase = () => {
    setVisible(true);
  };
  const developer = {
    freeInfo: {
      title: t("price.priceList.enterprise.freeText"),
      features: ["开发版功能一"],
    },
    features: [
      {
        title: `${t("price.priceList.develop.fun.item1.text")}`,
        tip: `${t("price.priceList.develop.fun.item1.comment")}`,
      },
      {
        title: `${t("price.priceList.develop.fun.item2.text")}`,
        tip: `${t("price.priceList.develop.fun.item2.comment")}`,
      },
      {
        title: `${t("price.priceList.develop.fun.item3.text")}`,
        tip: `${t("price.priceList.develop.fun.item3.comment")}`,
      },
      {
        title: `${t("price.priceList.develop.fun.item4.text")}`,
        tip: `${t("price.priceList.develop.fun.item4.comment")}`,
      },
      {
        title: `${t("price.priceList.develop.fun.item5.text")}`,
        tip: `${t("price.priceList.develop.fun.item5.comment")}`,
      },
    ],
    plans: [
      { min: 1, max: 1000, price: 169 },
      { min: 1000, max: 2500, price: 399 },
      { min: 2500, max: 5000, price: 629 },
      { min: 5000, max: 10000, price: 1029 },
      { min: 10000, max: 20000, price: 1999 },
      { min: 20000, max: 50000, price: 3799 },
      { min: 50000, max: "> 50,000", price: "--" },
    ],
    marks: {
      0: 0,
      1: 1,
      2: 2,
      3: 3,
      4: 4,
      5: 5,
      6: 6,
    },
    min: 0,
    max: 6,
    defaultValue: 0,
    title: `${t("price.priceList.develop.title")}`,
    button: `${t("common.button.try-now")}`,
    code: "develop",
  };

  const developerPro = {
    freeInfo: {
      title: t("price.priceList.enterprise.freeText"),
      features: ["专业版功能一"],
    },
    features: [
      {
        title: `${t("price.priceList.developPro.fun.item1.text")}`,
        tip: `${t("price.priceList.developPro.fun.item1.comment")}`,
      },
      {
        title: `${t("price.priceList.developPro.fun.item2.text")}`,
        tip: `${t("price.priceList.developPro.fun.item2.comment")}`,
      },
      {
        title: `${t("price.priceList.developPro.fun.item3.text")}`,
        tip: `${t("price.priceList.developPro.fun.item3.comment")}`,
      },
      {
        title: `${t("price.priceList.developPro.fun.item4.text")}`,
        tip: `${t("price.priceList.developPro.fun.item4.comment")}`,
      },
      {
        title: `${t("price.priceList.developPro.fun.item5.text")}`,
        tip: `${t("price.priceList.developPro.fun.item5.comment")}`,
      },
      {
        title: `${t("price.priceList.developPro.fun.item6.text")}`,
        tip: `${t("price.priceList.developPro.fun.item6.comment")}`,
      },
      {
        title: `${t("price.priceList.developPro.fun.item7.text")}`,
        tip: `${t("price.priceList.developPro.fun.item7.comment")}`,
      },
      {
        title: `${t("price.priceList.developPro.fun.item8.text")}`,
        tip: `${t("price.priceList.developPro.fun.item8.comment")}`,
      },
      {
        title: `${t("price.priceList.developPro.fun.item9.text")}`,
        tip: `${t("price.priceList.developPro.fun.item9.comment")}`,
      },
    ],
    plans: [
      { min: 1, max: 500, price: 999 },
      { min: 500, max: 1000, price: 1899 },
      { min: 1000, max: 2500, price: 3999 },
      { min: 2500, max: 10000, price: 6799 },
      { min: 10000, max: 20000, price: 12699 },
      { min: 20000, max: 50000, price: 14499 },
      { min: 50000, max: "> 50,000", price: "--" },
    ],
    marks: {
      0: 0,
      1: 1,
      2: 2,
      3: 3,
      4: 4,
      5: 5,
      6: 6,
    },
    min: 0,
    max: 6,
    defaultValue: 1,
    title: `${t("price.priceList.developPro.title")}`,
    button: `${t("common.button.try-now")}`,
    code: "developPro",
  };

  const enterprise = {
    theme: "dark",
    freeInfo: {
      title: t("price.priceList.enterprise.freeText"),
      features: ["企业版功能一", "企业版功能二", "企业版功能三"],
    },
    features: [
      {
        title: `${t("price.priceList.enterprise.fun.item1.text")}`,
        tip: `${t("price.priceList.enterprise.fun.item1.comment")}`,
      },
      {
        title: `${t("price.priceList.enterprise.fun.item2.text")}`,
        tip: `${t("price.priceList.enterprise.fun.item2.comment")}`,
      },
      {
        title: `${t("price.priceList.enterprise.fun.item3.text")}`,
        tip: `${t("price.priceList.enterprise.fun.item3.comment")}`,
        link: "/solutions/private-cloud",
      },
      {
        title: `${t("price.priceList.enterprise.fun.item4.text")}`,
        tip: `${t("price.priceList.enterprise.fun.item4.comment")}`,
      },
      {
        title: `${t("price.priceList.enterprise.fun.item5.text")}`,
        tip: `${t("price.priceList.enterprise.fun.item5.comment")}`,
      },
      {
        title: `${t("price.priceList.enterprise.fun.item6.text")}`,
        tip: `${t("price.priceList.enterprise.fun.item6.comment")}`,
      },
      {
        title: `${t("price.priceList.enterprise.fun.item7.text")}`,
        tip: `${t("price.priceList.enterprise.fun.item7.comment")}`,
      },
      {
        title: `${t("price.priceList.enterprise.fun.item8.text")}`,
        tip: `${t("price.priceList.enterprise.fun.item8.comment")}`,
      },
      {
        title: `${t("price.priceList.enterprise.fun.item9.text")}`,
        tip: `${t("price.priceList.enterprise.fun.item9.comment")}`,
      },
      {
        title: `${t("price.priceList.enterprise.fun.item10.text")}`,
        tip: `${t("price.priceList.enterprise.fun.item10.comment")}`,
      },
      {
        title: `${t("price.priceList.enterprise.fun.item11.text")}`,
        tip: `${t("price.priceList.enterprise.fun.item11.comment")}`,
      },
      {
        title: `${t("price.priceList.enterprise.fun.item12.text")}`,
        tip: `${t("price.priceList.enterprise.fun.item12.comment")}`,
      },
    ],
    plans: [
      // { min: 1, max: 200, price: 2999 },
      // { min: 200, max: 500, price: 5999 },
      // { min: 500, max: 1000, price: 9999 },
      // { min: 1000, max: 2500, price: 19999 },
      // { min: 2500, max: 5000, price: 32999 },
      // { min: 5000, max: 10000, price: 54999 },
      { min: 10000, max: "> 10,000", price: "--" },
    ],
    marks: {
      0: 0,
      1: 1,
      2: 2,
      3: 3,
      4: 4,
      5: 5,
      6: 6,
    },
    min: 0,
    max: 6,
    defaultValue: 0, //2
    title: `${t("price.priceList.enterprise.title")}`,
    button: `${t("common.button.try-now")}`,
    code: "enterprise",
  };
  return (
    <>
      <div className="price-list">
        <div className="inner">
          <div className="pay-way">
            <div>
              <span className={monthCls}>
                {t("price.priceList.payway.month")}
              </span>
              <Switch className="paye-type-switch" onChange={onSwitch} />
              <span className={annuallyCls}>
                {t("price.priceList.payway.year")}
              </span>
            </div>
            <div>
              {t("price.priceList.payway.comment-one")}
              <Tooltip
                placement="bottom"
                mouseLeaveDelay={0.001}
                trigger={["hover"]}
                overlay={<div> {t("price.priceList.common-tip")}</div>}
              >
                <span style={{ margin: "0 4px", cursor: "default" }}>
                  {t("price.priceList.MAU")}
                  <i
                    className="icon authing-icon authing-problem"
                    style={{ marginLeft: 6, color: "#999999" }}
                  ></i>
                </span>
              </Tooltip>
              {t("price.priceList.payway.comment-two")}
            </div>
          </div>
          <div className="price-item-warp">
            <PriceListItem
              {...developer}
              payeType={payeType}
              onPurchase={onPurchase}
            />
            <PriceListItem
              {...developerPro}
              payeType={payeType}
              onPurchase={onPurchase}
            />
            <PriceListItem
              {...enterprise}
              payeType={payeType}
              onPurchase={onPurchase}
            />
          </div>
        </div>
      </div>
      <ConsultFormModal {...{ visible, setVisible }} />
      {/* <ConsultModal {...{ visible, setVisible }} /> */}
    </>
  );
};
